<template>
    <div class="finshed" >
        <div class="flowChart ft14">
          <dl class="active">
            <ul>
              <li>
                <span></span>
              </li>
              <li @click="Process(0)">
                <div>
                  <span></span>
                </div>
                <p>填写信息</p>
              </li>
              <li>
                <span></span>
              </li>
            </ul>
          </dl>
          <dl class="active">
            <ul>
              <li>
                <span></span>
              </li>
              <li @click="Process(1)">
                <div>
                  <span></span>
                </div>
                <p>信息审核</p>
              </li>
              <li>
                <span></span>
              </li>
            </ul>
          </dl>
          <dl class="active">
            <ul>
              <li>
                <span></span>
              </li>
              <li @click="Process(2)">
                <div>
                  <span></span>
                </div>
                <p>支付费用</p>
              </li>
              <li>
                <span></span>
              </li>
            </ul>
          </dl>
          <dl class="active">
            <ul>
              <li>
                <span></span>
              </li>
              <li>
                <div @click="Process(3)">
                  <span></span>
                </div>
                <p>预约取证</p>
              </li>
              <li>
                <span></span>
              </li>
            </ul>
          </dl>
        </div>
        <div class="procedureTab">
          <div class="message ">
            <div class="messageLeft fl">
              <h5>
                <img src="../../../../../assets/images/procedure/information_icon.png">申请信息
              </h5>
              <div class="messageCon">
                <el-form>
                  <el-form-item label="申请公证名称：">{{returnList.name}}</el-form-item>
                  <el-form-item label="包含文件数量：">{{returnList.fileAmount}}</el-form-item>
                  <el-form-item label="文件总大小：">{{returnList.fileSize}}</el-form-item>
                  <el-form-item label="公证处：">{{returnList.office}}</el-form-item>
                  <el-form-item label="公证处地址：">{{returnList.address}}</el-form-item>
                  <el-form-item label="公证书份数：">{{returnList.paperAmount}}</el-form-item>
                  <el-form-item label="公证书领取：">
                    <span v-if="returnList.receiptorType==1">本人领取</span>
                    <span v-if="returnList.receiptorType==2">其他人自然领取</span>
                    <span v-if="returnList.receiptorType==3">账号使用者领取</span>
                  </el-form-item>
                  <el-form-item label="备注：">{{returnList.remarks}}</el-form-item>
                </el-form>
              </div>
            </div>
            <div class="messageLeft fr" v-if="type==1">
              <h5>
                <img src="../../../../../assets/images/procedure/contact_icon.png">联系信息
              </h5>
              <div class="messageCon">
                <el-form>
                  <el-form-item label="申请人：">{{returnList.applier}}</el-form-item>
                  <el-form-item label="身份证：">{{returnList.userIdCard}}</el-form-item>
                  <el-form-item label="户口所在地：">{{returnList.userDomicile}}</el-form-item>
                  <el-form-item label="现居住地址：">{{returnList.userAddress}}</el-form-item>
                  <el-form-item label="领取人姓名：">{{returnList.receiptor}}</el-form-item>
                  <el-form-item label="领取人身份证：">{{returnList.receiptorIdCard}}</el-form-item>
                  <el-form-item label="领取人手机号：">{{returnList.receiptorMobile}}</el-form-item>
                  <el-form-item label="领取人邮箱：">{{returnList.receiptorMail}}</el-form-item>
                </el-form>
              </div>
            </div>
            <div class="messageLeft fr" v-if="type==2">
              <h5>
                <img src="../../../../../assets/images/procedure/contact_icon.png">联系信息
              </h5>
              <div class="messageCon">
                <el-form v-if="returnList.receiptorType==1">
                  <el-form-item label="申请人：">{{returnList.applier}}</el-form-item>
                  <el-form-item label="营业执照注册号：">{{returnList.userIdCard}}</el-form-item>
                  <el-form-item label="公司所在地：">{{returnList.userAddress}}</el-form-item>
                  <el-form-item label="领取人姓名：">{{returnList.legalPersonName}}</el-form-item>
                  <el-form-item label="领取人身份证：">{{returnList.legalPersonIdcardNumber}}</el-form-item>
                  <el-form-item label="领取人手机号：">{{returnList.receiptorMobile}}</el-form-item>
                  <el-form-item label="领取人邮箱：">{{returnList.receiptorMail}}</el-form-item>
                </el-form>
                <el-form v-if="returnList.receiptorType==2">
                  <el-form-item label="申请人：">{{returnList.applier}}</el-form-item>
                  <el-form-item label="营业执照注册号：">{{returnList.userIdCard}}</el-form-item>
                  <el-form-item label="公司所在地：">{{returnList.userAddress}}</el-form-item>
                  <el-form-item label="领取人姓名：">{{returnList.receiptor}}</el-form-item>
                  <el-form-item label="领取人身份证：">{{returnList.receiptorIdCard}}</el-form-item>
                  <el-form-item label="领取人手机号：">{{returnList.receiptorMobile}}</el-form-item>
                  <el-form-item label="领取人邮箱：">{{returnList.receiptorMail}}</el-form-item>
                </el-form>
              </div>
            </div>
          </div>
          <div class="message ">
            <div class="messageStatus">
              <h5>
               <img src="../../../../../assets/images/procedure/audit_icon.png">审核状态
              </h5>
              <div class="messageCon">
                <img src="../../../../../assets/images/procedure/succeed_icon.png">
                <p>您的公证申请已通过审核！</p>
              </div>
            </div>
          </div>
          <div class="message ">
            <div class="moneyBox">
              <h5>
                <img src="../../../../../assets/images/procedure/audit_icon.png">审核状态
              </h5>
              <div class="messageCon">
                <el-table :data="tableData" border style="width: 100%">
                  <el-table-column prop="code" min-width="24.4%" label="公证编号"></el-table-column>
                  <el-table-column prop="office" min-width="16.2%" label="公证处"></el-table-column>
                  <el-table-column prop="applier" min-width="19.8%" label="申请人"></el-table-column>
                  <el-table-column prop="receiptor" min-width="14.4%" label="公证书领取人"></el-table-column>
                  <el-table-column prop="paperAmount" min-width="16.2%" label="公证书份数"></el-table-column>
                  <el-table-column prop="fileSize" min-width="9%" label="文件大小"></el-table-column>
                </el-table>
                <div class="footer">
                  <p class="fr" style="cursor: pointer;">
                    已付款:<span  class="pay">{{money}}</span>元
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="message active">
            <div class="messageStatus">
              <div class="messageCon">
                <img src="../../../../../assets/images/procedure/succeed_icon.png">
                <p>您已成功支付公证费用，请等待公证处制作公证书。公证处开始制证后我们会将取证时间通过短信发送到您的手机上，请您注意查收。在此期间如您有疑问可联系客服电话：010-86208510 </p>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import Dialog from "@common/Dialog.vue";
import BaseApi from "@lib/baseApi.js";
import {mapState, mapGetters} from "vuex";
export default {
  data(){
    return{
      type:1,
      money:'',
      notaryId:'',
      successFul:false,
      dialogVisible:false,
      id:'',
      returnList:{},
      tableData: [{
        code: "",
        office: "",
        userRegisterName: "",
        fileSize: "",
        applier: "",
        receiptor: "",
        paperAmount: ""
      }],
    }
  },
  computed:{
      ...mapState(['currentInfo','userInfo']),
  },
  mounted(){
     this.returnList = JSON.parse(sessionStorage.getItem("procedure"));
     this.tableData[0].code = this.returnList.code;
    this.tableData[0].office = this.returnList.office;
    this.tableData[0].userRegisterName = this.returnList.userRegisterName;
    this.tableData[0].fileSize = this.returnList.fileSize;
    this.tableData[0].applier = this.returnList.applier;
    this.tableData[0].receiptor = this.returnList.receiptor;
    this.tableData[0].paperAmount = this.returnList.paperAmount;
     this.Process(3);
     this.money = this.returnList.cost;
      this.notaryId=this.returnList.notaryId,
     this.id=this.$route.query.id;
  },
  methods:{
    Process(num) {
      console.log(num);
      $(".message").removeClass("active");
      $(".message")
        .eq(num)
        .addClass("active");
    },
  },
  components:{
    Dialog,
    BaseApi
  },
    created() {
     BaseApi.createRpcToken("/user/v2/getUserInfo")
      .then(data => {
          let userArr=[...[data.datas.person],...data.datas.enterpriseList];
          let curInfo=userArr.filter(item=>item.userId==data.datas.currentUserId)[0];
           this.type=curInfo.realNameType
      })
      .catch(function(e) {
        errorLog(e);
      });
    // this.type = JSON.parse(sessionStorage.getItem("userInfo")).realNameType;
  },
   watch:{
    "currentInfo"(data){
      this.$router.replace("/personal/serviceHome")
    }
  }
}
</script>
<style lang="scss">
.finshed {
      margin-top: 20px;
      .flowChart {
        width: 100%;
        padding-top: 40px;
        padding-bottom: 43px;
        overflow: hidden;
        height: 50px;
        li {
          float: left;
          height: 20px;
        }
        li:nth-child(2n-1) {
          position: relative;
          width: calc((100% - 112px) / 8);
          span {
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -1px;
            display: inline-block;
            width: 100%;
            height: 2px;
            background: #fbeceb;
            border-radius: 3px;
          }
        }
        dl.active {
          li:nth-child(2n-1) {
            span {
              background: #e98880;
            }
          }
          li:nth-child(2) {
            cursor: pointer;
            div {
              width: 20px;
              height: 20px;
              background: #fbeceb;
              border: 1px solid #e88078;
              border-radius: 50%;
              padding: 4px;
              box-sizing: border-box;
              margin: 0 4px;
            }
            span {
              display: block;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background: #e88078;
            }
          }
        }
        li:nth-child(2n) {
          position: relative;
          div {
            width: 20px;
            height: 20px;
            background: #fbeceb;
            border: 1px solid #fbeceb;
            border-radius: 50%;
            padding: 2px;
            box-sizing: border-box;
            margin: 0 4px;
          }
          p {
            position: absolute;
            width: 84px;
            color: #505050;
            top: 31px;
            left: -26px;
            text-align: center;
          }
        }
        .select {
          span {
            background: #e98880 !important;
          }
        }
      }
      .procedureTab {
       width: 100%;
        display: table;
       .putIn {
        text-align: center;
        span {
          display: inline-block;
          border: 1px solid #e29999;
          width: 140px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          font-size: 12px;
          color: #e29999;
        }
      }
      .message {
        display: none;
        h5 {
          background: #f7f7f7;
          height: 32px;
          line-height: 32px;
          font-size: 14px;
          padding-left: 20px;
          color: #646464;
          font-weight: normal;
          border-bottom: 1px solid #e4e8eb;
          img {
            vertical-align: middle;
            margin-right: 4px;
          }
        }
        .messageLeft {
          width: calc(96% / 2);
          display: table;
          border: 1px solid #e4e8eb;
          margin-bottom: 20px;
          .messageCon {
            width: 100%;
            box-sizing: border-box;
            height: 377px;
            background: #fafafa;
            position: relative;
            .el-form {
              padding-left: 43px;
              padding-top: 25px;
              .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
                content: '';
              }
              .el-form-item {
                font-size: 12px;
                color: #646464;
                margin-bottom: 20px;
                .el-form-item__label {
                  line-height: 24px;
                  padding: 0;
                  width: 150px;
                  text-align: left;
                }
                .el-form-item__content {
                  line-height: 24px;
                }
              }
              .el-form-item__content {
                position: relative;
                .el-input {
                  width: 296px;
                  .el-input__inner {
                    padding-left: 10px;
                    height: 20px;
                    line-height: 20px;
                    border-radius: 0;
                  }
                }
                .el-form-item__error {
                  left: 152px;
                }
              }
              .subBox {
                position: absolute;
                bottom: -30%;
                left: -100px;
                .el-button {
                  width: 140px;
                  line-height: 36px;
                  padding: 0;
                  background-color: #fff;
                  font-size: 12px;
                  color: #e29999;
                  border-color: #e29999;
                }
              }
              .el-button:hover {
                color: #fff;
                background-color: #a5303d;
                border-color: #a5303d;
              }
            }
            .numFile{
              position: relative;
              p{
                position: absolute;
                left:150px;
                color: #f56c6c;
                font-size: 12px;
              }
            }
            .fileNum {
              background: #f0f0f0;
              height: 20px;
              width: 60px;
              border-radius: 2px;
              font-size: 12px;
              color: #646464;
              position: relative;
              .el-input__inner {
                padding: 0;
                height: 20px;
                line-height: 20px;
                padding-left: 10px;
                box-sizing: border-box;
              }
            }
          }
        }
        .messageLeft:nth-child(1) {
          margin-right: 3%;
        }
        .messageStatus {
          width: 100%;
          border: 1px solid #e4e8eb;
          .messageCon {
            display: flex;
            width: 100%;
            box-sizing: border-box;
            height: 240px;
            background: #fafafa;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            font-size: 14px;
            color: #646464;
            img {
              margin-bottom: 10px;
            }
            p {
              width: 60%;
              text-align: center;
            }
          }
        }
        .moneyBox {
          border: 1px solid #e4e8eb;
          .messageCon {
            background: #fafafa;
            width: 100%;
            height: 161px;
            padding: 20px 11px;
            box-sizing: border-box;
            table {
              table-layout: auto;
              thead {
                width: 100%;
              }
              th:nth-child(1),
              td:nth-child(1) {
                width: "24.4%";
              }
              th:nth-child(2),
              td:nth-child(2) {
                width: "16.2%";
              }
              th:nth-child(3),
              td:nth-child(3) {
                width: "19.8%";
              }
              th:nth-child(4),
              td:nth-child(4) {
                width: "14.4%";
              }
              th:nth-child(5),
              td:nth-child(5) {
                width: "16.2%";
              }
              th:nth-child(6),
              td:nth-child(6) {
                width: "9";
              }
              th {
                background: #f9f9f9;
              }
              td {
                background-color: #fff;
              }
              th,
              td {
                padding: 0;
                vertical-align: middle;
                width: 100px;
                overflow: hidden;
                .cell {
                  height: 30px;
                  line-height: 30px;
                  text-align: center;
                }
              }
            }
            p {
              text-align: right;
              font-size: 12px;
              color: #969696;
              margin-top: 28px;
              span {
                font-size: 24px;
                color: #e88078;
              }
            }
          }
        }
      }
      .active {
        display: block;
      }
      }
      // .footer{
      //   span{
      //     font-size: 24px;
      //     color: #003200;
      //   }
      // }
    }
</style>
